import { useEffect } from 'react';
import { CONNECT_INFO } from '../constants/connect';

const ensureMetaTag = (selector, attributes) => {
  if (typeof document === 'undefined') return null;
  const existing = document.head.querySelector(selector);
  if (existing) return existing;
  const tag = document.createElement('meta');
  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });
  document.head.appendChild(tag);
  return tag;
};

const setMetaContent = (name, content) => {
  if (typeof document === 'undefined') return;
  if (!content) return;
  const tag = ensureMetaTag(`meta[name="${name}"]`, { name });
  if (tag) tag.setAttribute('content', content);
};

const setPropertyMetaContent = (property, content) => {
  if (typeof document === 'undefined') return;
  if (!content) return;
  const tag = ensureMetaTag(`meta[property="${property}"]`, { property });
  if (tag) tag.setAttribute('content', content);
};

export default function usePageMeta({
  title,
  description,
  image,
  url,
  type = 'website',
}) {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    if (title) {
      document.title = title;
    }

    if (description) {
      setMetaContent('description', description);
    }

    const resolvedUrl = url || (typeof window !== 'undefined' ? window.location.href : undefined);
    const resolvedImage = image || CONNECT_INFO.officePhoto;

    if (title) {
      setPropertyMetaContent('og:title', title);
    }
    if (description) {
      setPropertyMetaContent('og:description', description);
    }
    if (resolvedImage) {
      setPropertyMetaContent('og:image', resolvedImage);
    }
    if (resolvedUrl) {
      setPropertyMetaContent('og:url', resolvedUrl);
    }
    setPropertyMetaContent('og:type', type);
    setPropertyMetaContent('og:site_name', CONNECT_INFO.brand);
  }, [title, description, image, url, type]);
}